/*
 * popup modal
 */
const popupModal = function() {
	$('.js-modal').addClass('no-scroll');
	$('.js-modal').magnificPopup({
		type: 'inline',
		removalDelay: 500,
		fixedContentPos: false,
		fixedBgPos: true,
		callbacks: {
			beforeOpen: function() {
				this.st.mainClass = this.st.el.attr('data-effect');
				$('body').css("overflow-y", "hidden");
			},
			open: function() {
				$('html').css('margin-right', '0');
				//$('.l-header').css('padding-right', '15px');
			},
			close: function() {
				$('body').css("overflow-y", "auto");
			},
		},
		midClick: true,
		showCloseBtn: false,
	});

	$(document).on('click', '.js-modal-close', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});
}


/*
 * init
 */
popupModal();
